import { EVENT_REQUEST_SUCCESS, FetchEventsSuccessAction, UpdateLastViewedAction, EVENT_MARK_VIEWED } from "../actions/events";
import { Action } from "redux";
import { EventObject } from "../util/events";

const LAST_VIEWED_STORAGE_KEY = 'timeline_last_viewed_at';

export interface EventsState {
  total: number
  byId: { [id: string]: EventObject; }
  lastViewedAt: Date | null
  isPolling: boolean
}

function getLastViewedFromStorage(): Date | null {
  const stored = localStorage.getItem(LAST_VIEWED_STORAGE_KEY);
  if (stored) {
    return new Date(stored);
  }
  return null;
}

const defaultState: EventsState = {
  total: 0,
  byId: {},
  lastViewedAt: getLastViewedFromStorage(),
  isPolling: false,
};

export function eventsReducer(state = defaultState, action: Action) {
  switch (action.type) {
    case EVENT_REQUEST_SUCCESS:
      return handleRequestSucess(state, action as FetchEventsSuccessAction)
    case EVENT_MARK_VIEWED:
      return handleMarkViewed(state, action as UpdateLastViewedAction)
    default:
      return state;
  }
};

function handleRequestSucess(state: EventsState, action: FetchEventsSuccessAction) {
  const events = action.events

  // Merge new events with existing ones (for polling support)
  const newIndexedEvents = [...events].reduce((acc, event: EventObject) => {
    acc[event.id] = event;
    return acc;
  }, {} as { [id: string]: EventObject });

  return {
    ...state,
    total: action.total,
    byId: {
      ...(action.reset ? {} : state.byId),  // Keep existing events by default
      ...newIndexedEvents  // Add/overwrite with new events
    },
  }

}

function handleMarkViewed(state: EventsState, action: UpdateLastViewedAction) {
  const sorted = Object.values(state.byId).sort((e1, e2) => e2.createdAt.getTime() - e1.createdAt.getTime())
  if (sorted.length === 0) return state;

  localStorage.setItem(LAST_VIEWED_STORAGE_KEY, sorted[0].createdAt.toISOString());

  return {
    ...state,
    lastViewedAt: sorted[0].createdAt
  }
}
